import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

(function() {

    const sliders = document.querySelectorAll('.gallery-slides');
    if (!sliders.length) {
        return;
    }

    for (let i = 0; i < sliders.length; i++) {
        const sliderElement = sliders[i];

        if (sliderElement.querySelectorAll('.swiper-slide').length <= 1) {
            continue;
        }

        let config = {
            slidesPerView: 'auto',
            spaceBetween: 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            modules: [Pagination],
            on: {}
        }

        // навигация

        const gallery = sliderElement.closest('.gallery');
        if (gallery) {
            const prev = gallery.querySelector('.js-gallery-nav-prev');
            const next = gallery.querySelector('.js-gallery-nav-next');

            if (prev && next) {
                config.modules.push(Navigation);
                config.navigation = {
                    prevEl: prev,
                    nextEl: next,
                    disabledClass: 'is-disabled'
                }
            }
        }

        const slider = new Swiper(sliderElement, config);
    }

}());